import { render, staticRenderFns } from "./CartDiscount.vue?vue&type=template&id=2901978b&"
import script from "./CartDiscount.vue?vue&type=script&lang=js&"
export * from "./CartDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports